import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import { AppSettings } from '../constants';
// import cookie from 'react-cookies';
import PubSub from '../services/pubsub-service';
import * as PubSubActionType from 'services/constants';
import { ObjToParam, MapResponse } from './helper-api';

const Interceptors = (base_url = '', isLoading = true, { ...args }) => {
  let baseURL = base_url;
  if (document.location.protocol === 'https:') {
    baseURL = base_url ? base_url.replace('http://', 'https://') : '';
  }

  // baseURL = 'http://localhost:8053/';

  var hiddenIndicator = () => {
    if (isLoading) {
      setTimeout(() => {
        PubSub.publish(PubSubActionType.LOADING_INDICATOR, {
          isHideIndicator: true
        });
      }, 500);
    }
  };

  var instance = null;

  if (baseURL) {
    instance = axios.create({
      baseURL: baseURL
    });

    if (args.responseType) {
      instance = axios.create({
        baseURL: baseURL,
        responseType: args.responseType
      });
    }
  } else {
    instance = axios.create({});
  }

  instance.interceptors.request.use(
    config => {
      PubSub.publish(PubSubActionType.RESET_HANDLING_ERROR, null);

      if (isLoading) {
        PubSub.publish(PubSubActionType.LOADING_INDICATOR, {
          isHideIndicator: false
        });
      }

      var access_token = localStorage[AppSettings.S1_TOKEN];

      config.headers.common['Cache-Control'] = 'no-cache, no-store';
      config.headers.common['Content-Type'] = 'application/json';
      config.headers.common['accept'] = 'application/json';
      config.headers.common['Pragma'] = 'no-cache';
      config.headers.common['Expires'] = 0;

      if (access_token) {
        config.headers.common['Authorization'] = `Bearer ${access_token}`;
      }

      if (!isEmpty(args.headers)) {
        forEach(args.headers, headerItem => {
          config.headers.common[headerItem.key] = headerItem.value;
        });
      }

      return config;
    },
    error => {
      hiddenIndicator();

      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    response => {
      hiddenIndicator();
      return response;
    },
    error => {
      hiddenIndicator();

      if (error.message === 'Network Error') {
        const errorMsg =
          'Sorry, we are unable to reach this site at the moment. Please try again later.';

        error.response = {
          data: errorMsg,
          status: 500
        };

        return Promise.reject(error);
      }

      if (!error.response) {
        error.response = {
          data:
            'The server encountered an internal error. Please contact the administrator',
          status: 500
        };

        return Promise.reject(error);
      }

      var status = error.response.status;
      switch (status) {
        case 401:
          // PubSub.publish(PubSubActionType.TOKEN_EXPIRED, null);
          window.location.href = `${window.location.origin}/logout`;
          break;
        case 400:
          //TODO 400
          break;
        case 403:
          // TODO 403
          error.response.data =
            'You don\'t have permission to access this page.';
          PubSub.publish(PubSubActionType.ACCESS_DENIED_ERROR, null);
          break;
        case 500:
          {
            if (error.response.data && error.response.data.error) {
              error.response.data = error.response.data.error;
            } else {
              error.response.data =
                'The server encountered an internal error. Please contact the administrator';
            }
          }
          break;
        default:
          break;
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

const sendAjaxRequest = (base_url = '', uri, params, m, isLoading = true) => {
  let instance;
  let method;
  if (!m) {
    method = 'GET';
  } else {
    method = m;
  }
  let newUri = uri;
  if (document.location.protocol === 'https:') {
    newUri = uri ? uri.replace('http://', 'https://') : '';
  }

  if (method.toUpperCase() === 'GET') {
    let query = params ? `?${ObjToParam(params)}` : '';
    instance = Interceptors(base_url, isLoading).get(`${newUri}${query}`);
  } else if (method.toUpperCase() === 'DELETE') {
    instance = Interceptors(base_url, isLoading).delete(`${newUri}`, params);
  } else if (method.toUpperCase() === 'PUT') {
    instance = Interceptors(base_url, isLoading).put(`${newUri}`, params);
  } else {
    instance = Interceptors(base_url, isLoading).post(`${newUri}`, params);
  }
  return instance
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export { sendAjaxRequest };
export default Interceptors;



// WEBPACK FOOTER //
// ./src/helper/interceptors.js